// extracted by mini-css-extract-plugin
var _1 = "payment-module_button_bright__Poq2pc";
var _2 = "payment-module_head_title__Ye4Jzp";
var _3 = "payment-module_note__mTUxc2";
var _4 = "payment-module_whosName__O8Nf8u";
export { _1 as "button_bright", _2 as "head_title", _3 as "note", _4 as "whosName" }
